/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Kpi } from './kpi';


/**
 * A row of headline KPIs displayed at the top of a tab to give an at-a-glance summary before the detailed content below.
 */
export interface KpiListBlock { 
    /**
     * Discriminator identifying this block as a KPI list.
     */
    type?: KpiListBlock.TypeEnum;
    /**
     * Ordered list of KPIs to render left to right.
     */
    kpis: Array<Kpi>;
}
export namespace KpiListBlock {
    export const TypeEnum = {
        KpiList: 'kpi-list'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


